"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.notInTimestampRange = void 0;
const field_types_1 = require("../types/field_types");
const notInTimestampRange = (timestamp) => {
    return timestamp < field_types_1.DateRange.MinTimeStamp || timestamp > field_types_1.DateRange.MaxTimeStamp;
};
exports.notInTimestampRange = notInTimestampRange;
//# sourceMappingURL=not_in_timestamp_range.js.map